// extracted by mini-css-extract-plugin
module.exports = {"pending-change-requests":"PendingChangeRequests_pending-change-requests__tSwPh"};